import { inject, Injectable } from '@angular/core';
import { ɵRuntimeError as RuntimeError } from '@angular/core';
import { PlatformService } from 'ngx-unificator/services';

const HAMMER_GESTURES = [
  'pan', 'panstart', 'panmove', 'panend', 'pancancel',
  'swipe', 'tap', 'press', 'pinch', 'rotate',
];

@Injectable()
export class HammerEventsPlugin {
  private _platform = inject(PlatformService);

  supports(eventName: string): boolean {
    return HAMMER_GESTURES.some(g => eventName.toLowerCase().startsWith(g));
  }

  addEventListener(
    element: HTMLElement,
    eventName: string,
    handler: (e: any) => void,
  ): () => void {
    if (!this._platform.isBrowser) {
      return () => {
      };
    }

    return this._setupHammer(element, eventName, handler);
  }

  private _setupHammer(
    element: HTMLElement,
    eventName: string,
    handler: (e: any) => void,
  ): () => void {
    let destroyed = false;
    let mc: any;

    import('hammerjs')
      .then(HammerModule => {
        if (destroyed) return; // если dispose уже вызван

        const Hammer = HammerModule.default ?? HammerModule;
        mc = new Hammer.Manager(element);

        mc.add(new Hammer.Pan({ direction: Hammer.DIRECTION_ALL }));
        mc.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_ALL }));
        mc.add(new Hammer.Tap());
        mc.add(new Hammer.Press());
        mc.add(new Hammer.Pinch({ enable: true }));
        mc.add(new Hammer.Rotate({ enable: true }));

        mc.on(eventName, handler);
      })
      .catch(() => {
        console.warn('[HammerEventsPlugin] Failed to load hammerjs');
      });

    return () => {
      destroyed = true;
      if (mc) {
        try {
          mc.off(eventName, handler);
          mc.destroy();
        } catch {
          throw new RuntimeError(-1, `Hammer cleanup error for ${eventName}`);
        }
      }
    };
  }
}
